import { COLORS } from '../../config/colors/colors';
import { styled } from 'goober';
import { stylesIconWrapperByType, stylesWrapperByType } from './toast.mixins';
import { ToastType } from './types';

export const Wrapper = styled('div')<{ $type: ToastType }>`
    position: relative;
    display: flex;
    max-width: 380px;
    padding: 12px 12px 12px 16px;
    border-radius: 12px;
    overflow: hidden;
    gap: 12px;
    align-items: flex-start;
    z-index: 1000000000;
    background-color: ${COLORS.neutral_00};
    ${stylesWrapperByType};
`;

export const IconWrapper = styled('div')<{ $type: ToastType }>`
    flex-shrink: 0;
    ${stylesIconWrapperByType}
`;

export const CloseWrapper = styled('div')`
    flex-shrink: 0;
    cursor: pointer;
`;

export const Content = styled('div')`
    display: flex;
    gap: 4px;
    flex-direction: column;
`;
